import { useContext } from "react";
import { LoadingStateContext } from "../SimulationProvider";

export const useLoadingState = () => {
  const state = useContext(LoadingStateContext);
  return state;
};
